declare global {
    interface Window {
        dataLayer: Record<string, unknown>[];
    }
}

function push(payload: Record<string, unknown>) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}

export function gtmPageView(path: string, title?: string) {
    push({
        event: 'page_view',
        page_path: path,
        page_title: title || document.title,
    });
}

export function gtmAuthEvent(action: 'sign_in' | 'sign_up' | 'sign_out', method?: 'email' | 'apple') {
    push({ event: action, method: method ?? 'email' });
}

export function gtmEvent(name: string, params?: Record<string, unknown>) {
    push({ event: name, ...params });
}

export function gtmError(errorType: string, errorMessage: string) {
    push({ event: 'app_error', error_type: errorType, error_message: errorMessage });
}
